import React, { useState } from 'react';
import { Modal } from './Modal';
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  return <footer className="bg-charcoal text-cream-200 py-12 border-t border-charcoal-light/20" data-id="element-68">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-70">
          <div className="text-center md:text-left" data-id="element-71">
            <p className="font-serif text-xl font-bold text-white mb-2" data-id="element-72">
              Protocolo Cero Aullidos
            </p>
            <p className="text-sm text-cream-200/60" data-id="element-73">
              © {new Date().getFullYear()} Todos los derechos reservados.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-74">
            <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-white transition-colors" data-id="element-75">
              Política de Privacidad
            </button>
            <button onClick={() => setIsTermsOpen(true)} className="hover:text-white transition-colors" data-id="element-76">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </div>

      <Modal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} title="Política de Privacidad" data-id="element-77">
        <div className="space-y-4" data-id="element-78">
          <p data-id="element-79">
            En Protocolo Cero Aullidos, respetamos su privacidad y estamos
            comprometidos a proteger la información personal que comparte con
            nosotros.
          </p>
          <h3 className="font-bold text-charcoal mt-6 mb-2" data-id="element-80">
            1. Recopilación de Información
          </h3>
          <p data-id="element-81">
            Recopilamos información cuando usted se registra en nuestro sitio,
            realiza un pedido o se suscribe a nuestro boletín. La información
            recopilada incluye su nombre, dirección de correo electrónico y
            detalles de pago.
          </p>
          <h3 className="font-bold text-charcoal mt-6 mb-2" data-id="element-82">
            2. Uso de la Información
          </h3>
          <p data-id="element-83">
            Cualquier información que recopilamos de usted puede ser utilizada
            para: personalizar su experiencia, mejorar nuestro sitio web,
            mejorar el servicio al cliente y procesar transacciones.
          </p>
          <h3 className="font-bold text-charcoal mt-6 mb-2" data-id="element-84">
            3. Protección de la Información
          </h3>
          <p data-id="element-85">
            Implementamos una variedad de medidas de seguridad para mantener la
            seguridad de su información personal cuando realiza un pedido o
            ingresa, envía o accede a su información personal.
          </p>
          <p className="text-sm mt-8 italic" data-id="element-86">
            Última actualización: {new Date().toLocaleDateString('es-AR')}
          </p>
        </div>
      </Modal>

      <Modal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Términos y Condiciones" data-id="element-87">
        <div className="space-y-4" data-id="element-88">
          <p data-id="element-89">
            Al acceder y utilizar este sitio web y adquirir el "Protocolo Cero
            Aullidos", usted acepta estar sujeto a los siguientes términos y
            condiciones.
          </p>
          <h3 className="font-bold text-charcoal mt-6 mb-2" data-id="element-90">
            1. Uso del Producto
          </h3>
          <p data-id="element-91">
            El material proporcionado es únicamente para uso personal y
            educativo. No se permite la reventa, distribución o modificación del
            contenido sin el consentimiento expreso por escrito.
          </p>
          <h3 className="font-bold text-charcoal mt-6 mb-2" data-id="element-92">2. Resultados</h3>
          <p data-id="element-93">
            Los resultados pueden variar según el perro, su historial y la
            consistencia en la aplicación del método. No garantizamos resultados
            específicos, ya que el comportamiento animal depende de múltiples
            factores.
          </p>
          <h3 className="font-bold text-charcoal mt-6 mb-2" data-id="element-94">
            3. Propiedad Intelectual
          </h3>
          <p data-id="element-95">
            Todo el contenido, incluyendo textos, gráficos, logotipos e
            imágenes, es propiedad de Protocolo Cero Aullidos y está protegido
            por las leyes de propiedad intelectual.
          </p>
          <p className="text-sm mt-8 italic" data-id="element-96">
            Última actualización: {new Date().toLocaleDateString('es-AR')}
          </p>
        </div>
      </Modal>
    </footer>;
}